module.exports = __webpack_public_path__ + "img/logo-techpaf-blanc.d08df2cd.png";